import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authed/cartographies/$id/')({
	beforeLoad: ({ params }) => {
		throw redirect({ to: '/cartographies/$id/classic', params: { id: params.id } })
	}
})
